<template>
  <modal name="registercube" :scrollable="true" height="auto">

         <div class="modal-content">
           <div class="modal-header">
             <h5 class="modal-title">Register cube</h5>
             <button type="button" class="close" @click="$modal.hide('registercube')">
               <span aria-hidden="true">&times;</span>
             </button>
           </div>
           <div class="modal-body">
                <h4 @click="whereFindId()" class="wherecanfindid-title">Where can you find cubeid? <span>&#9432;</span></h4> 

                <div v-if="wherefindid" class="wherecanfindid" @click="whereFindId()"> 
                  <h5>Steps:</h5>
                  <ol>
                    <li>Login to cube via TeamViewer </li>
                    <li>Run terminal (lxterminal) </li>
                    <li>Look at line eg. " di@printcube0007324e2eea" your cube id is "printcube0007324e2eea" </li>
                  </ol>
                </div>

                <p v-if="errorRepeat" class="errormessage label-input" :class="{'error': this.errorRepeat}">Cube id must be start with "printcube"</p>
                <label class="label-input" :class="{'error': this.errorRepeat}">
                    Cube ID: 
                    <input type="text" class="form-control" v-model="cubeid" placeholder="cubeid">
                </label>
           </div>
           <div class="modal-footer">
             <button type="button" class="btn btn-primary mr-2" @click="$modal.hide('registercube')">LEAVE</button>
             <button type="button" class="btn btn-secondary" @click="registerCube">REGISTER</button>
             <div v-if="tasksGenerated">
                <a href="/#/Account?tab=updatetasks" class="btn btn-outline-secondary ml-2">Go to your tasks</a>
              </div>
           </div>
         </div>

  </modal>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Vue from 'vue'
export default {
    name: 'RegisterCubeModal',
    props: {
        shopid: {
            type: String
        }
    },
    data(){
        return {
            cubeid: "",
            repeatcubeid: "",
            showrepeat: false,
            errorRepeat: false,
            wherefindid: false,
            tasksGenerated: false,
        }
    },
    computed: {
      ...mapGetters(['getUserId']),
    },
    methods: {
        ...mapMutations(['addAlert']),
        ...mapActions([ 'createTaskAsync' ]),
        async registerCube(){

          if(this.cubeid && this.cubeid.startsWith("printcube")){
            this.errorRepeat = false;
          }else {
            this.errorRepeat = true;
            return;
          }
          const env = `${process.env.VUE_APP_ENV}`;
          const branch = `${process.env.VUE_APP_BRANCH}`;

          this.emitWithKey('update-envs', { cube: this.cubeid, data: { 
              setupid: this.shopid,
              environment: env,
              branch: branch
          } });
          // this.createTask({cube: this.cubeid, toSend: { 
          //   setupid: this.shopid || this.$route.params.id,
          //   environment: env,
          //   branch: branch
          // }});

          this.addAlert({
              title: 'Success ',
              type: 'success',
              body: 'to register cube in that shop. Please wait a moment for registration end.'
          });
          try {
            await Vue.axios.post('/collecter/classes/registercubeslogs', { cube: this.cubeid, setupid: this.setupid, env, userid: this.getUserId, data: { type: "registercube", "success": true} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
          } catch (error) {
            console.error(error);
          }
        },
        emitWithKey (method, data) {
            data.data.key = '8FD71A527448';
            data.state = '';
            this.$socket.client.emit(method, data);
        },
        whereFindId(){
          this.wherefindid = !this.wherefindid;
        },
        async createTask({cube = [], contexts = [], toSend = {}}){
          const {id} = await this.createTaskAsync({cubes: Array.isArray(cube) ? cube : [cube], contexts, userID: this.getUserId, toSend})
          this.tasksGenerated = true;
        },
    }


}
</script>

<style lang="scss" scoped>
.label-input {
  float: none;

  &.error {
    color: red;
  }

  &.errormessage {
    font-size: 16px;
  }
}

.wherecanfindid {
  cursor: pointer;
  padding: 15px;
  font-size:16px;
}

.wherecanfindid-title {
  cursor: pointer;
}
</style>